import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';

import WavyLayout from './../../hoc/WavyLayout/WavyLayout';

import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';

//-- Utils
import { pushHeaderTitle } from '../../utils/dom/helper';
import { pushPageView } from '../../utils/tracking/customGtm';

export class Contact extends Component {

    componentDidMount() {
        //-- Update title
        pushHeaderTitle('Contact');

        //-- Push GTM page view
        pushPageView();
    }

    handleClick = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    }
    
    render(){

        return (

            <WavyLayout 
                page="contact"
                title="Contact"
                color="gradient"
                handleClick={this.handleClick}>
                
                <div className="contact">
                    <div className="text title">
                        Pour écrire <span className="no-wrap">à nos journalistes</span>
                    </div>
                    <div className="polaroid-container">
                        <div className="polaroid aurelie">
                            <div className="picture"></div>
                            <div className="name">Aurélie Selvi</div>
                            <div className="email">aselvi@nicematin.fr</div>
                        </div>
                        <div className="polaroid sandrine">
                            <div className="picture"></div>
                            <div className="name">Sandrine Beigas</div>
                            <div className="email">sbeigas@nicematin.fr</div>
                        </div>
                        <div className="blue-shape">
                            <Zigzag color="#49d1e5" />
                        </div>
                        <div className="yellow-shape">
                            <Zigzag color="#ffde39" />
                        </div>
                        <div className="plane"></div>
                    </div>
                    
                    <div className="text problem">
                        Problème de connexion, <span className="no-wrap">abonnement, question sur Kids-Matin...</span><br />
                            Écrivez nous à
                    </div>
                    <div className="group">
                        <div className="label"></div>
                        <div className="kidsmatin-email"><div className="text">kidsmatin@nicematin.fr</div></div>
                    </div>
                    
                </div>
            </WavyLayout>
        );
    }
}

export default connect( null )(Contact);



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js